import React, { Suspense } from 'react';
import Spinner from 'react-bootstrap/Spinner';
// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component: any) => (props: any) =>
  (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );


  const Loader = ({ customClassName = "" }: any) => {
    return (
      <div
        className={`flex items-center justify-center h-screen w-full ${customClassName}`}
      >
        <Spinner animation="border" variant="info" />
      </div>
    );
  };
  

export {Loader};
export default Loadable;
